import { formatCurrency } from '../../../shared/utils/general.util';

const AnnualPreviewInfoItem = ({
	label,
	value,
	variant = 'default',
	className,
	classNameValue,
}: {
	label: string;
	value: string | number;
	variant?: 'default' | 'bold';
	className?: string;
	classNameValue?: string;
}) => {
	return (
		<p className={`flex justify-between ${className}`}>
			<span className={`font-light ${variant === 'bold' ? 'font-medium' : ''}`}>
				{label}:
			</span>
			<span className={`font-medium md:text-base ${classNameValue}`}>
				{formatCurrency(Number(value))}
			</span>
		</p>
	);
};

export default AnnualPreviewInfoItem;
